{
    "base": "vs",
    "inherit": true,
    "rules": [
      {
        "token": "comment",
        "foreground": "626F86"
      },
	  {
        "token": "keyword",
        "foreground": "AE2E24"
      },
	  {
		"token": "string",
		"foreground": "A54800"
	  },
	  {
		"token": "number",
		"foreground": "0055CC"
	  },
	  {
		"token": "identifier",
		"foreground": "172B4D"
	  },
	  {
		"token": "keyword.directive",
		"foreground": "172B4D"
	  },
	  {
		"token": "string.include.identifier",
		"foreground": "172B4D"
	  },
	  {
		"token": "tag",
		"foreground": "0C66E4"
	  },
	  {
		"token": "attribute.value",
		"foreground": "216E4E"
	  },
	  {
		"token": "attribute.name",
		"foreground": "216E4E"
	  },
	  {
		"token": "attribute.value.hex.css",
		"foreground": "A54800"
	  },
	  {
		"token": "attribute.value.number.css",
		"foreground": "0055CC"
	  },
	  {
		"token": "attribute.value.unit.css",
		"foreground": "0055CC"
	  },
	  {
		"token": "metatag.html",
		"foreground": "172B4D"
	  },
	  {
		"token": "metatag.content.html",
		"foreground": "172B4D"
	  },
	  {
		"token": "delimiter.html",
		"foreground": "172B4D"
	  },
	  {
		"token": "attribute.value.html",
		"foreground": "A54800"
	  },
	  {
		"token": "string.key.json",
		"foreground": "216E4E"
	  },
	  {
        "token": "metatag.php",
        "foreground": "AE2E24",
		"fontStyle": ""
      },
	  {
        "token": "variable",
        "foreground": "09326C"
      },
	  {
		"token": "variable.predefined",
		"foreground": "172B4D"
	  },
	  {
		"token": "operator.sql",
		"foreground": "172B4D"
	  },
	  {
		"token": "string.sql",
		"foreground": "A54800"
	  },
	  {
		"token": "predefined.sql",
		"foreground": "216E4E"
	  },
	  {
		"token": "type.identifier.swift",
		"foreground": "216E4E"
	  },
      {
        "token": "entity.name.function",
        "foreground": "216E4E"
      },
      {
        "token": "entity.name.type.class",
        "foreground": "216E4E"
      },
      {
        "token": "storage.type.function",
        "foreground": "AE2E24"
      },
      {
        "token": "storage.type.class",
        "foreground": "AE2E24"
      },
      {
        "token": "constant.language",
        "foreground": "AE2E24"
      }
    ],
    "colors": {
      "editor.background": "#ffffff",
      "editorCursor.foreground": "#172B4D"
    }
}